import { GET_AXON_HOST } from "../../constants/env";
import fetchWrapper from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export type TPostCreateServicesMasterRequestProps = {
  service_name: string;
  price: number;
  clinic_id: string;
};

export default async function postCreateServicesMaster(
  serviceCreateData: TPostCreateServicesMasterRequestProps
): Promise<AxonGenericApiResponse<{}>> {
  const AXON_HOST = GET_AXON_HOST();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
    body: JSON.stringify(serviceCreateData),
  };

  const response = await fetchWrapper(
    `${AXON_HOST}/autosuggest/services-master`,
    requestOptions
  );
  return await response.json();
}
